var React = require('react');

function HaskellPlain (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#b37feb","d":"M0,110.2L30.1,65L0,19.9h22.6L52.7,65l-30.1,45.1H0z","key":0}),React.createElement("path",{"fill":"#b37feb","d":"M30.1,110.2L60.2,65L30.1,19.9h22.6l60.2,90.3H90.4L71.5,81.9l-18.8,28.2H30.1z","key":1}),React.createElement("path",{"fill":"#b37feb","d":"m102.9 83.8-10-15.1h35.1v15.1h-25.1zm-15.1-22.5-10-15.1h50.2v15.1h-40.2z","key":2})]);
}

HaskellPlain.defaultProps = {"enableBackground":"new 0 0 128 128","version":"1.1","viewBox":"0 0 128 128","xmlSpace":"preserve"};

module.exports = HaskellPlain;

HaskellPlain.default = HaskellPlain;
